
import React from 'react'
import { connect } from 'react-redux'
import ReactPlayer from 'react-player'
import privateUrl from '../assets/private_game.jpg'

const aspectRatio = 1280/720
const padding = (100 / aspectRatio) + '%'

class VideoPlayer extends React.Component {
    state = { playing: true  }

    componentDidMount() {
        document.body.onclick = this.handleBodyClick
    }

    handleBodyClick = () => {
        if (this.state.playing)
            return
        this.setState({ playing: true })
    }

    render() {
        const { videoUrl, user, isPrivate } = this.props
        const { playing } = this.state
        const { is_mobile } = user
        return (
            <div style={{ position: 'relative', paddingBottom: padding }}>
                { isPrivate?
                    <img src={privateUrl} style={{ display: 'block', position: 'absolute', top: 0, left: 0, width: '100%' }} />
                    :
                   videoUrl ? 
                    /*<ReactPlayer url={videoUrl} style={{ position: 'absolute', top: 0, left: 0 }}
                        width='100%' height='100%'
                        playing={playing} controls volume={this.props.silenced?'0':'1'} muted={!is_mobile?true:false} 
                        config = {{
                         youtube:{
                            playerVars:{
                                autoplay: 1,
                                fs: 0,
                            }

                         },
                         twitch:{
                            options:{
                                allowfullscreen: false,
                                autoplay: true,
                                playsinline: true
                            }
                         },
                         file:{
                             forceHLS:true
                         }   

                        }}
                        /> */
                        <iframe width="100%" src={videoUrl} frameborder="0" style={{position:'absolute',height:'100%'}}  allow="autoplay"></iframe>
                        :
                    <img src='https://res.cloudinary.com/www-blackanswer-it/image/upload/v1586214749/next_game_kbibqj.jpg' style={{ display: 'block', position: 'absolute', top: 0, left: 0, width: '100%' }} />
                }
            </div>
        )
    }
}


const mapStateToProps = (state) => ({
    user: state.user,
    videoUrl: state.live_video_url
})

export default connect(
    mapStateToProps
)(VideoPlayer)


// WEBPACK FOOTER //
// ./src/components/VideoPlayer.js